import Gold from 'assets/images/gold.svg'
import Silver from 'assets/images/silver.svg'
import I18n from 'components/I18n'
import { OverlayLoader } from 'components/Loaders'
import { actions, selectors } from 'data'
import messages from 'lang'
import React, { useEffect } from 'react'
import { FormattedNumber } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { TIERS } from 'services/api'
import styled from 'styled-components'

import { Button, SecondaryButton, Wrapper } from './styles'

const Badge = styled.img`
  height: 3rem;
  width: 3rem;
`

const Section = styled.section`
  text-align: center;
  margin-top: 3rem;

  p {
    margin: 0;
  }
`

const GoldPrompt = ({ onDepositClick, onGoldClick }) => {
  const tiers = useSelector(selectors.auth.getTierDefinitions)
  const dispatch = useDispatch()
  useEffect(function fetchUserLimitsOnMount() {
    dispatch(actions.auth.getTiersLimitsVolume())
  }, [])
  if (!tiers)
    return (
      <Wrapper>
        <OverlayLoader />
      </Wrapper>
    )

  return (
    <Wrapper>
      <Section>
        <Badge src={Silver} />
        <h2>
          <I18n data={messages.title_approved_tier_1} />
        </h2>
        <p>
          <I18n data={messages.unlimited_trading} />
        </p>
        <p>
          <I18n data={messages.crypto_deposits} />
        </p>
        <p>
          <I18n data={messages.withdrawal_limits_desc} type={<I18n data={messages.crypto} />} />{' '}
          <FormattedNumber
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            value={tiers[TIERS.TIER_ONE].WITHDRAWAL_CRYPTO.YEAR}
          />{' '}
          <I18n data={messages.per_year} />
        </p>
        <Button onClick={onDepositClick}>
          <I18n data={messages.deposit_to_trade} />
        </Button>
      </Section>
      <Section>
        <Badge src={Gold} />
        <h2>
          <I18n data={messages.gold_verification} />
        </h2>
        <p>
          <I18n data={messages.unlimited_trading} />
        </p>
        <p>
          <I18n data={messages.crypto_and_fiat_deposits} />
        </p>
        <p>
          <I18n data={messages.withdrawal_limits_desc} type={<I18n data={messages.crypto} />} />{' '}
          <FormattedNumber
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            value={tiers[TIERS.TIER_TWO].WITHDRAWAL_CRYPTO.WEEK}
          />{' '}
          <I18n data={messages.per_week} />
        </p>
        <p>
          <I18n data={messages.withdrawal_limits_desc} type={<I18n data={messages.fiat} />} />{' '}
          <FormattedNumber
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            value={tiers[TIERS.TIER_TWO].WITHDRAWAL_FIAT.WEEK}
          />{' '}
          <I18n data={messages.per_week} />
        </p>
        <SecondaryButton onClick={onGoldClick}>
          <I18n data={messages.button_continue_to_gold} />
        </SecondaryButton>
      </Section>
    </Wrapper>
  )
}

export default GoldPrompt
